import { render } from "./teachingStat.vue?vue&type=template&id=29527af4&scoped=true"
import script from "./teachingStat.vue?vue&type=script&lang=js"
export * from "./teachingStat.vue?vue&type=script&lang=js"

import "./teachingStat.vue?vue&type=style&index=0&id=29527af4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29527af4"]])

export default __exports__